module.exports = __webpack_public_path__ + "img/icon-eye.85724f08.svg";